import { useRef } from 'react';
import { StyledAllieTooltip } from './Tooltip.styles';

interface AllieTooltipProps {
  triggerId: string;
  children: any;
}

export const AllieTooltip: React.FC<AllieTooltipProps> = ({ triggerId, children }) => {
  const tooltipRef = useRef<HTMLIonPopoverElement>(null);

  const popoverMouseEvents = {
    onmouseleave: () => {
      tooltipRef.current?.dismiss();
    },
  };

  return (
    <StyledAllieTooltip
      ref={tooltipRef}
      trigger={triggerId}
      triggerAction="hover"
      alignment="center"
      side="top"
      showBackdrop={false}
      content={{
        className: 'ion-padding',
        children,
        ...popoverMouseEvents,
      }}
    />
  );
};
